import {FC} from 'react';
import type {SelectedBank} from '../../model/selectedBank';
import {BankListPanel} from 'features/registration/ui/components/BankListPanel/BankListPanel';
import styles from './SbpBankStep.module.css';

type Props = {
	selectedBank: SelectedBank | null;
	onSelect: (bank: SelectedBank) => void;
};

export const SbpBankStep: FC<Props> = ({selectedBank, onSelect}) => {
	return (
		<div className={styles.root}>
			<h2 className={styles.title}>Выберите банк</h2>

			<div className={styles.content}>
				<BankListPanel sbpBanksOnly selectedBankId={selectedBank?.id ?? null} onSelect={onSelect} />
			</div>
		</div>
	);
};
